import React from "react";
import cx from "classnames";
import PropTypes from "prop-types";
import { Col, Row } from "reactstrap";

import global from "../../../scss/dhp.scss";
import CommonLineLoader from "./commonLineLoader";

let style = Object.assign({}, global);

const SingleColLoader = ({ lineCount, colCount = 6 }) => {
  return (
    <>
      {[...Array(lineCount)].map((_, i) => (
        <Row cssModule={style} key={`singleCol-${i}`}>
          <Col cssModule={style} xs={colCount}>
            <CommonLineLoader width={40} height="16px" loaderClass="pb-2" />
            <CommonLineLoader width={99} height="44px" loaderClass="pb-4" />
          </Col>
        </Row>
      ))}
    </>
  );
};

SingleColLoader.propTypes = {
  lineCount: PropTypes.number,
};

const DoubleColLoader = ({ lineCount, doubleCol }) => {
  return (
    <>
      {doubleCol && <CommonLineLoader width={25} height="24px" loaderClass="pb-4" />}
      {[...Array(lineCount)].map((_, i) => (
        <Row cssModule={style} key={`doubleCol-${i}`}>
          <Col cssModule={style} xs={6}>
            <CommonLineLoader width={40} height="16px" loaderClass="pb-2" />
            <CommonLineLoader width={99} height="44px" loaderClass="pb-4" />
          </Col>
          <Col cssModule={style} xs={6}>
            <CommonLineLoader width={40} height="16px" loaderClass="pb-2" />
            <CommonLineLoader width={99} height="44px" loaderClass="pb-4" />
          </Col>
        </Row>
      ))}
    </>
  );
};

DoubleColLoader.propTypes = {
  doubleCol: PropTypes.bool,
  lineCount: PropTypes.number,
};

const FormLoader = ({ doubleCol = false, lineCount = 1, sectionCount = 1, colCount, hideCommonLine = false }) => {
  return (
    <div className={cx(style["template-directory"], style["pt-4"])}>
      {!hideCommonLine && (
        <div>
          <CommonLineLoader width={20} height="32px" loaderClass="pb-4" />
        </div>
      )}
      {[...Array(sectionCount)].map((_, i) => (
        <div
          className={cx(style["fixed-container"], { [style["mb-5"]]: doubleCol, [style["mt-3"]]: doubleCol })}
          key={`loader-${i}`}>
          {!doubleCol && <SingleColLoader colCount={colCount} lineCount={lineCount} />}

          {doubleCol && <DoubleColLoader lineCount={lineCount} doubleCol={doubleCol} />}
        </div>
      ))}
    </div>
  );
};

FormLoader.propTypes = {
  doubleCol: PropTypes.bool,
  lineCount: PropTypes.number,
  sectionCount: PropTypes.number,
};

export default FormLoader;
